import React from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

// import { useAll as useSpheres } from "modules/sphere/hooks";
import { useAll as useOrganizations } from "modules/organization/hooks";

import * as Grid from "components/Grid";

import Input from "components/Input";
import Select from "components/Select";
import Button from "components/Button";
import Label from "components/Label";

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();

  // const sphere = useSpheres();
  const organization = useOrganizations();

  return (
    <Grid.Row style={{
      flex: "1",
    }} gutter={[16, 8]} align="bottom">
      <Grid.Col xs={12}>
        <Label title={t(`column_organization`)}>
          <Select
            onChange={v => setParams({ organization_id: v })}
            showSearch
            options={[
              { label: t("all_organization"), value: "" },
              ...organization.items.map(item => ({
                label: item.name[i18n.language],
                value: item.id,
              })),
            ]}
            value={Number(params.organization_id) || ""}
            placeholder={t("column_organization")}
            disabled={!organization.isFetched}
          />
        </Label>
      </Grid.Col>

      {/*<Grid.Col xs={4}>*/}
      {/*  <Select*/}
      {/*    onChange={v => setParams({ sphere_id: v })}*/}
      {/*    showSearch*/}
      {/*    options={[*/}
      {/*      { label: t("all_sphere"), value: "" },*/}
      {/*      ...sphere.items.map(item => ({ label: item.name, value: item.id })),*/}
      {/*    ]}*/}
      {/*    value={Number(params.sphere_id) || ""}*/}
      {/*    placeholder={t("column_sphere")}*/}
      {/*    disabled={!sphere.isFetched}*/}
      {/*  />*/}
      {/*</Grid.Col>*/}

      <Grid.Col xs={12}>
        <Label title={t("column_service_name")}>
          <Input
            onChange={e => setParams({ service_name: e || undefined })}
            placeholder={t("column_service_name")}
            value={params.service_name || ""}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={7}>
        <Label title={t("column_service_form")}>
          <Select
            onChange={e => setParams({ service_form: e })}
            options={[
              {
                label: t("all"),
                value: "",
              },
              {
                label: t("TRADITIONAL"),
                value: "TRADITIONAL",
              },
              {
                label: t("ONLINE"),
                value: "ONLINE",
              },
              {
                label: t("TRADITIONAL_AND_ONLINE"),
                value: "TRADITIONAL_AND_ONLINE",
              },
            ]}
            placeholder={t("column_service_form")}
            value={params.service_form || ""}
          />
        </Label>
      </Grid.Col>
      <Grid.Col xs={7}>
        <Label title={t("column_subject_type")}>
          <Select
            onChange={e => setParams({ subject_type: e })}
            options={[
              {
                label: t("all"),
                value: "",
              },
              {
                label: t("INDIVIDUAL"),
                value: "INDIVIDUAL",
              },
              {
                label: t("LEGAL_ENTITY"),
                value: "LEGAL_ENTITY",
              },
              {
                label: t("INDIVIDUAL_AND_LEGAL"),
                value: "INDIVIDUAL_AND_LEGAL",
              },
            ]}
            placeholder={t("column_subject_type")}
            value={params.subject_type || ""}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={7}>
        <Label title={t("column_payment_type")}>
          <Select
            onChange={e => setParams({ payment_type: e })}
            options={[
              {
                label: t("all"),
                value: "",
              },
              {
                label: t("PAID"),
                value: "PAID",
              },
              {
                label: t("FREE"),
                value: "FREE",
              },
              {
                label: t("MIXED"),
                value: "MIXED",
              },
            ]}
            placeholder={t("column_payment_type")}
            value={params.payment_type || ""}
          />
        </Label>
      </Grid.Col>
      <Grid.Col xs={3}>
          <Button
            style={{ width: "100%" }}
            background="blue"
            color="white"
            border="blue"
            radius="sm"
            onClick={() => setSearch(prev => prev + 1)}>
            <Icons.Search /> {t("find")}
          </Button>
      </Grid.Col>
    </Grid.Row>
  );
};

export default FilterList;
